export default __webpack_public_path__ + "fc8bbb08b3d0e1030c772fc555aa8bd3.png";